<template>
  <div class='date_picker'>
     <el-date-picker
      style="width:300px"
      v-model="nowDate"
      type="datetime"
      placeholder="选择日期时间"
      align="right"
      :picker-options='pickerOptions'
      value-format='yyyy-MM-dd HH:mm:ss'
      @change='selectChange'>
    </el-date-picker>
  </div>
</template>

<script>
export default {
  name:'date_picker',
  props:{
    initDate:{
      type:String,
      default:''
    }
  },
  data(){
    return {
      nowDate:'',
      pickerOptions: {
        shortcuts: [{
          text: '今天',
          onClick(picker) {
            picker.$emit('pick', new Date());
          }
        }, {
          text: '昨天',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24);
            picker.$emit('pick', date);
          }
        }, {
          text: '一周前',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', date);
          }
        }]
      }
    };
  },
  created(){
    if(this.initDate!==''){
      this.nowDate=this.initDate;
    }
  },
  methods:{
    selectChange(){
      this.$emit('change',this.nowDate);
    }
  }
};
</script>

<style scoped>
.el-date-editor{
  width: 300px;
}
</style>